import Link from './Link'

export default [
    { path: '/link/:link', component: Link }
]
